<template>
  <div>
    <h1 class="mb-8 font-bold text-2xl md:text-3xl ">
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('clients')">Klienci</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      {{ firma }}
    </h1>
    <blocked-message v-if="client.deleted_at" class="mb-6" @restore="restore">
      Ten klient jest całkowicie zablokowany.
    </blocked-message>

    <div class="flex flex-wrap">
      <div class="bg-white rounded-md shadow overflow-hidden w-full xl:w-1/2">
        <form @submit.prevent="update">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
            <multiselect-input v-model="form.firma" :error="form.errors.firma" class="pr-6 pb-8 w-full lg:w-1/2" :options="firmy" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" label="Firma [WAPRO]" :isDisabled="!$page.props.can['change firma']" :searchable="true" />

            <multiselect-input v-model="form.user" :error="form.errors.user" class="pr-6 pb-8 w-full lg:w-1/2" :options="users_opt" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" label="Opiekun" />

            <multiselect-input v-model="form.kontrahent" :error="form.errors.kontrahent" class="pr-6 pb-8 w-full" :options="kontrahenci" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" label="Kontrahent [WAPRO]" :isDisabled="client.kontrahent != null && !$page.props.can['change kontrahent']" :searchable="true" />

            <text-input v-model="form.nazwa_pelna" :error="form.errors.nazwa_pelna" class="pr-6 pb-8 w-full" label="Nazwa" v-if="form.firma == null" />

            <text-input v-model="form.nip" :error="form.errors.nip" class="pr-6 pb-8 w-full lg:w-1/3" label="NIP" v-if="form.firma == null" />
            <text-input v-model="form.regon" :error="form.errors.regon" class="pr-6 pb-8 w-full lg:w-1/3" label="REGON" v-if="form.firma == null" />
            <text-input v-model="form.krs" :error="form.errors.krs" class="pr-6 pb-8 w-full lg:w-1/3" label="KRS" v-if="form.firma == null" />

            <inertia-link class="pr-6 pb-8 flex items-center text-shtax-500 focus:text-shtax-700 w-full" :href="route('clients.address', {'client':client.id})">
              <fa icon="folder" class="w-5 h-5 pt-1 mr-3" fixed-width />  Lista adresów klienta
            </inertia-link>

            <text-input v-model="form.kod_pocztowy" :error="form.errors.kod_pocztowy" class="pr-6 pb-8 w-full lg:w-1/2" label="Kod pocztowy" :disabled="form.kontrahent != null" />
            <text-input v-model="form.miejscowosc" :error="form.errors.miejscowosc" class="pr-6 pb-8 w-full lg:w-1/2 disabled:bg-gray-400" label="Miejscowość" :disabled="form.kontrahent != null" />
            <text-input v-model="form.ulica_lokal" :error="form.errors.ulica_lokal" class="pr-6 pb-8 w-full disabled:bg-gray-100" label="Ulica lokal" :disabled="form.kontrahent != null" />

            <shtax-text-area-input class="pr-6 pb-8 w-full" v-model="form.rodzaj_zus" :error="form.errors.rodzaj_zus" label="Rodzaj ZUS"  />
            <shtax-text-area-input class="pr-6 pb-8 w-full" v-model="form.umowa_o_prace" :error="form.errors.umowa_o_prace" label="Umowa o pracę"  />

            <shtax-checkbox class="pt-8 pr-6 pb-8 w-full lg:w-1/2" v-model:checked.sync="form.is_jdg" :error="form.errors.is_jdg" :checked="form.is_jdg" label="Jednoosobowa działalność gospodarcza"  />
            <text-input v-model="form.start_dg" :error="form.errors.start_dg" class="pr-6 pb-8 w-full lg:w-1/2" label="Data rozpoczęcia DG" type="date" />
            <shtax-checkbox class="pr-6 pb-8 w-1/2 lg:w-1/2" v-model:checked.sync="form.upl_1" :error="form.errors.upl_1" :checked="form.upl_1" label="Złożone UPL-1" />
            <shtax-checkbox class="pr-6 pb-8 w-1/2 lg:w-1/2" v-model:checked.sync="form.zus_pel" :error="form.errors.zus_pel" :checked="form.zus_pel" label="Złożone pełnomocnictwo ZUS-PEL" />

          </div>
          <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center" v-if="$page.props.can['edit clients']">
            <button v-if="!client.deleted_at && $page.props.can['delete clients']" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">
              <fa icon="lock" fixed-width /> Zablokuj całkowicie
            </button>
            <loading-button :loading="form.processing" class="btn-shtax ml-auto" type="submit">Aktualizuj dane klienta</loading-button>
          </div>
        </form>
      </div>

      <div class="mt-12 xl:mt-0 xl:px-8 w-full xl:w-1/2" v-if="$page.props.can['see clients history']">
        <h3 class="mb-2 font-bold text-lg md:text-md ">
          Historia klienta <small class="text-gray-400">(ostatnie 10 wpisów)</small>
        </h3>
        <div class="mt-2 bg-white rounded shadow overflow-x-auto text-sm">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="px-3 pt-3 pb-2">Data operacji</th>
              <th class="px-3 pt-3 pb-2">Użytkownik</th>
              <th class="px-3 pt-3 pb-2">Informacja</th>
            </tr>
            <tr v-for="history in client.history" :key="history.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
              <td class="border-t">
                <span class="px-3 py-2 flex items-center focus:text-shtax-500">
                  {{ history.created_at }}
                </span>
              </td>
              <td class="border-t">
                <span class="px-3 py-2 flex items-center" tabindex="-1">
                  {{ history.user.first_name }} {{ history.user.last_name }}
                </span>
              </td>
              <td class="border-t">
                <span class="px-3 py-2 flex items-center whitespace-normal" tabindex="-1">
                  {{ history.description }}
                </span>
              </td>
            </tr>
            <tr v-if="client.history.length === 0">
              <td class="border-t px-3 py-2" colspan="3">Historia kontrahenta jest pusta.</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    
    <h2 class="mt-12 font-bold text-xl md:text-2xl relative">
      Kontakty / Udziałowcy
      <div class="inline">
        <inertia-link class="btn-shtax ml-auto absolute right-0 top-0 disabled:opacity-50" :href="route('contacts.create', client.id)" v-if="!client.deleted_at">
          <span>Nowy</span>
          <span class="hidden md:inline">kontakt</span>
        </inertia-link>
      </div>
    </h2>
    
    <div class="mt-6 bg-white rounded shadow overflow-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Imię i nazwisko</th>
          <th class="px-6 pt-6 pb-4">Adres e-mail</th>
          <th class="px-6 pt-6 pb-4">Komórka</th>
          <th class="px-6 pt-6 pb-4">Właściciel</th>
          <th class="px-6 pt-6 pb-4">PESEL</th>
          <th class="px-6 pt-6 pb-4">Stanowisko</th>
          <th class="px-6 pt-6 pb-4">Udziałowiec</th>
          <th class="px-6 pt-6 pb-4" colspan="2">Domyślny</th>
        </tr>
        <tr v-for="contact in client.contacts" :key="contact.id" class="hover:bg-gray-100 focus-within:bg-gray-100" :class="{'bg-green-50':contact.is_default, 'bg-red-50':contact.deleted_at}">
          <td class="border-t">
              <inertia-link class="px-6 py-4 flex items-center focus:text-shtax-500" :href="route('contacts.edit', {'client':client.id, 'contact':contact.id})">
                <span>
                  {{ contact.first_name }} {{ contact.last_name }}
                </span>
              </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-shtax-500" :href="route('contacts.edit', {'client':client.id, 'contact':contact.id})">
              <span>
                {{ contact.email }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-shtax-500" :href="route('contacts.edit', {'client':client.id, 'contact':contact.id})">
              <span>
                {{ contact.phone }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-shtax-500" :href="route('contacts.edit', {'client':client.id, 'contact':contact.id})">
              <span>
                {{ contact.is_ceo ? 'Tak' : 'Nie' }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-shtax-500" :href="route('contacts.edit', {'client':client.id, 'contact':contact.id})">
              <span>
                {{ contact.pesel }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-shtax-500" :href="route('contacts.edit', {'client':client.id, 'contact':contact.id})">
              <span>
                {{ contact.stanowisko }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-shtax-500" :href="route('contacts.edit', {'client':client.id, 'contact':contact.id})">
              <span>
                {{ contact.wapro_udzialowiec_id ? 'Tak' : 'Nie' }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-shtax-500" :href="route('contacts.edit', {'client':client.id, 'contact':contact.id})">
              <span>
                {{ contact.is_default ? 'Tak' : 'Nie' }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t relative overflow-visible">
            <dropdown class="" placement="bottom-end">
              <div class="flex items-center cursor-pointer select-none group">
                <fa icon="ellipsis-v" class="w-5 h-5 mr-4 group-hover:text-shtax-600 text-gray-700 focus:text-shtax-600" />
              </div>
              <div slot="dropdown" class="ml-3 mt-2 py-2 shadow-xl bg-white rounded text-sm absolute top-0 right-0 w-max" >
                <inertia-link class="block pl-3 pr-6 py-2 hover:bg-shtax-500 hover:text-white" :href="route('contacts.edit', {'client':client.id, 'contact':contact.id})">
                  <fa icon="edit" class="w-5 h-5 mr-2 group-hover:text-shtax-600 text-gray-700 focus:text-shtax-600" /><span class="align-top">Podgląd/Zmiana</span>
                </inertia-link>

                <inertia-link class="block pl-3 pr-6 py-2 hover:bg-shtax-500 hover:text-white" :href="route('sharer-history', {'contact':contact.id})" v-if="contact.wapro_udzialowiec_id">
                  <fa icon="hand-holding-usd" class="w-5 h-5 mr-2 group-hover:text-shtax-600 text-gray-700 focus:text-shtax-600" /><span class="align-top">Historia udziałowca</span>
                </inertia-link>
                <span class="block pl-3 pr-6 py-2 hover:text-gray-700" v-else><fa icon="hand-holding-usd" class="w-5 h-5 mr-2 group-hover:text-shtax-600 text-gray-700 focus:text-shtax-600" /><span class="align-top">Historia udziałowca</span></span>

                <inertia-link class="block pl-3 pr-6 py-2 hover:bg-shtax-500 hover:text-white" :href="route('mailbox.contacts', {'contact':contact.id})" v-if="contact.email">
                  <fa icon="mail-bulk" class="w-5 h-5 mr-2 group-hover:text-shtax-600 text-gray-700 focus:text-shtax-600" /><span class="align-top">Wysłane na e-mail</span>
                </inertia-link>
                <span class="block pl-3 pr-6 py-2 hover:text-gray-700" v-else><fa icon="mail-bulk" class="w-5 h-5 mr-2 group-hover:text-shtax-600 text-gray-700 focus:text-shtax-600" /><span class="align-top">Wysłane na e-mail</span></span>

              </div>
            </dropdown>
          </td>
        </tr>
        <tr v-if="client.contacts.length === 0">
          <td class="border-t px-6 py-4" colspan="7">Brak kontaktów kontrahenta.</td>
        </tr>
      </table>
    </div>

    <h2 class="mt-12 font-bold text-xl md:text-2xl relative">
        Umowy
        <div class="inline">
            <inertia-link class="btn-shtax ml-auto absolute right-0 top-0 disabled:opacity-50" :href="route('contracts.create', client.id)" v-if="!client.deleted_at && client.contacts.length > 0">
              <span>Nowa</span>
              <span class="hidden md:inline">umowa</span>
            </inertia-link>
        </div>
    </h2>
    
    <div class="mt-6 bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-3 pt-6 pb-2">Numer</th>
          <th class="px-3 pt-6 pb-2">Data<br>podpisania</th>
          <th class="px-3 pt-6 pb-2">Usługa<br>od</th>
          <th class="px-3 pt-6 pb-2">Cenniki</th>
          <th class="px-3 pt-6 pb-2">Cennik<br>promocyjny</th>
          <th class="px-3 pt-6 pb-2">Szablon</th>
          <th class="px-3 pt-6 pb-2">Uwagi</th>
          <th class="px-3 pt-6 pb-2" colspan="2">Wydruk</th>
        </tr>
        <tr v-for="contract in client.contracts" :key="contract.id" class="hover:bg-gray-100 focus-within:bg-gray-100" :class="{'bg-red-50':contract.deleted_at != null, 'bg-orange-50':contract.started_from == null&& contract.signed_at == null}">
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('contracts.edit', {'client':client.id, 'contract':contract.id})">
              <span>
                {{ contract.number }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('contracts.edit', {'client':client.id, 'contract':contract.id})">
              <span>
                {{ contract.signed_at }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('contracts.edit', {'client':client.id, 'contract':contract.id})">
              <span>
                {{ contract.started_from }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('contracts.edit', {'client':client.id, 'contract':contract.id})">
              <span>
                {{ contract.price_list.type.name }} - {{ contract.price_list.name }}
                <span v-if="contract.price_list_kadry"><br>{{ contract.price_list_kadry.type.name }} - {{ contract.price_list_kadry.name }}</span>
              </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('contracts.edit', {'client':client.id, 'contract':contract.id})">
              <template v-if="contract.has_promotion">
              Tak do: {{ contract.promotion_ends_on }}
              </template>
              <template v-else>Nie</template>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('contracts.edit', {'client':client.id, 'contract':contract.id})">
              <span>
                {{ contract.theme.name }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('contracts.edit', {'client':client.id, 'contract':contract.id})">
              <span>
                {{ contract.uwagi }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <a class="px-3 py-2 flex items-center focus:text-shtax-500" v-if="client.contacts.length > 0" :href="contract.pdf_url" target="_blank">
              <fa icon="print" fixed-width />
            </a>
          </td>
          <td class="border-t w-px">
            <inertia-link class="px-4 flex items-center" :href="route('contracts.edit', {'client':client.id, 'contract':contract.id})" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="client.contracts.length === 0">
          <td class="border-t px-3 py-2" colspan="8">Brak umów z klientem. <span class="text-red-400" v-if="client.contacts.length === 0">Aby dodać umowę musisz najpierw dodać kontakt!</span></td>
        </tr>
      </table>
    </div>

    <h2 class="mt-12 font-bold text-xl md:text-2xl relative">
        Definicje faktur
        <div class="inline">
            <inertia-link class="btn-shtax ml-auto absolute right-0 top-0 disabled:opacity-50" :href="route('factures.create', client.id)" v-if="!client.deleted_at && client.contracts.length > 0">
              <span>Nowa</span>
              <span class="hidden md:inline">faktura</span>
            </inertia-link>
        </div>
    </h2>
    
    <div class="mt-6 bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap text-sm">
        <tr class="text-left font-bold">
          <th class="px-3 pt-3 pb-2">#</th>
          <th class="px-3 pt-3 pb-2">Umowa</th>
          <th class="px-3 pt-3 pb-2">Magazyn</th>
          <th class="px-3 pt-3 pb-2">Blokada<br>wystawiania</th>
          <th class="px-3 pt-3 pb-2">Forma<br>płatności</th>
          <th class="px-3 pt-3 pb-2">Liczba<br>pozycji</th>
          <th class="px-3 pt-3 pb-2">Uwagi</th>
          <th class="px-3 pt-3 pb-2" colspan="2">Ostatnio<br>wystawiono</th>
        </tr>
        <tr v-for="facture in client.factures" :key="facture.id" class="hover:bg-gray-100 focus-within:bg-gray-100" :class="{'bg-red-50':facture.is_blocked}">
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('factures.edit', {'client':client.id, 'facture':facture.id})">
              <span>
                {{ facture.id }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('factures.edit', {'client':client.id, 'facture':facture.id})">
              <span>
                {{ facture.contract.number }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('factures.edit', {'client':client.id, 'facture':facture.id})">
              <span>
                {{ facture.magazyn.NAZWA }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('factures.edit', {'client':client.id, 'facture':facture.id})">
              <span>
                {{ facture.is_blocked ? 'Tak' : 'Nie' }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('factures.edit', {'client':client.id, 'facture':facture.id})">
              <span>
                {{ facture.forma_platnosci.NAZWA }} ({{ facture.forma_platnosci.DNI_NALEZNOSCI }} dni)
              </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('factures.edit', {'client':client.id, 'facture':facture.id})">
              <span>
                {{ facture.positions.length }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('factures.edit', {'client':client.id, 'facture':facture.id})">
              <span>
                {{ facture.uwagi }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('factures.edit', {'client':client.id,'facture':facture.id})">
              <span v-if="facture.last_dh" :class="{'text-shtax-500':facture.last_dh.ile_dni>60, 'text-yellow-500':facture.last_dh.ile_dni>30&&facture.last_dh.ile_dni<=60}">
                {{ facture.last_dh.NUMER }} w {{ facture.last_dh.DATA_SPRZEDAZY }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t w-px">
            <inertia-link class="px-2 flex items-center" :href="route('factures.edit', {'client':client.id, 'facture':facture.id})" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="client.factures.length === 0">
          <td class="border-t px-6 py-4" colspan="8">Brak zdefiniowanych faktur. <span class="text-red-400" v-if="client.contracts.length === 0">Aby zdefiniować fakturę musisz najpierw dodać umowę!</span></td>
        </tr>
      </table>
    </div>

  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import BlockedMessage from '@/ShtaxComponents/BlockedMessage'
import ShtaxCheckbox from '@/ShtaxComponents/Checkbox'
import ShtaxTextAreaInput from '@/ShtaxComponents/TextAreaInput'
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'
import Swal from 'sweetalert2'
import Dropdown from '@/Shared/Dropdown'

export default {
  metaInfo() {
    return { title: this.client.firma ? this.client.firma.NAZWA_PELNA : this.client.nazwa_pelna }
  },
  components: {
    Icon,
    LoadingButton,
    SelectInput,
    TextInput,
    BlockedMessage,
    ShtaxCheckbox,
    ShtaxTextAreaInput,
    MultiselectInput,
    Dropdown
  },
  layout: Layout,
  props: {
    client: Object,
    users: Array,
    firmy: Array,
    kontrahenci: Array
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        nazwa_pelna: this.client.firma ? this.client.firma.NAZWA_PELNA : this.client.nazwa_pelna,
        ulica_lokal: this.client.kontrahent && this.client.kontrahent.ULICA_LOKAL ? this.client.kontrahent.ULICA_LOKAL : this.client.ulica_lokal,
        kod_pocztowy: this.client.kontrahent && this.client.kontrahent.KOD_POCZTOWY ? this.client.kontrahent.KOD_POCZTOWY : this.client.kod_pocztowy,
        miejscowosc: this.client.kontrahent && this.client.kontrahent.MIEJSCOWOSC ? this.client.kontrahent.MIEJSCOWOSC : this.client.miejscowosc,
        rodzaj_zus: this.client.rodzaj_zus,
        umowa_o_prace: this.client.umowa_o_prace,
        is_jdg: this.client.is_jdg,
        upl_1: this.client.upl_1,
        zus_pel: this.client.zus_pel,
        nip: this.client.nip,
        regon: this.client.regon,
        start_dg: this.client.start_dg,
        krs: this.client.krs,
        user: this.client.user ? {'id': this.client.user_id, 'name': this.client.user.first_name +' '+ this.client.user.last_name} : null,
        firma: this.client.firma ? {'id': this.client.wapro_firma_id, 'name': this.client.firma.NAZWA_PELNA} : null,
        kontrahent: this.client.kontrahent ? {'id': this.client.wapro_kontrahent_id, 'name': this.client.kontrahent.NAZWA_PELNA} : null
      }),
      users_opt: this.users.map(user => {return {'id': user.id, 'name': user.first_name +' '+ user.last_name}}),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('clients.update', this.client.id))
    },
    destroy() {
      Swal.fire({
        title: 'Jesteś pewien że chcesz zablokować wybranego klienta?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Tak, zablokuj!',
        cancelButtonText: 'Nie'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(this.route('clients.destroy', this.client.id))
        }
      })
    },
    restore() {
      Swal.fire({
        title: 'Jesteś pewien że chcesz przywrócić i odblokować wybranego klienta?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Tak, przywróć i odblokuj!',
        cancelButtonText: 'Nie'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.put(this.route('clients.restore', this.client.id))
        }
      })
    },
  },

  computed: {
    firma() {
      return this.client.firma ? this.client.firma.NAZWA_PELNA : this.client.nazwa_pelna
    }
  }

}
</script>
